export default __webpack_public_path__ + "static/media/Group 3534.0afbdaf6.jpg";